/* HoloHunterz product image lightbox: replaces the stock zoom on product pages.
   Opens at a moderate zoom; pinch / wheel / double-tap / +- zoom in or out to the full image (fit);
   drag pans; only X, Esc or a tap on the backdrop closes (zooming out stops at fit); swipe or arrows change image.
   Uses full-resolution images. Image protection (holo-protect.js) still applies (images are draggable=false, menu blocked). */
(function () {
  'use strict';
  if (window.__holoLb) return; window.__holoLb = true;
  document.documentElement.classList.add('holo-zl-ready'); // hides the theme's own product zoom modal (CSS) so only this viewer runs
  var OPEN_ZOOM = 1, MAX = 5, DBL = 2.5;
  var box, stage, img, counter, prevB, nextB, list = [], idx = 0, s = 1, tx = 0, ty = 0, lastFocus = null;
  var pts = {}, gesture = null, lastTap = 0;

  function fullRes(u) {
    if (!u) return '';
    try { var x = new URL(u, location.href); x.searchParams.delete('width'); x.searchParams.delete('height'); x.searchParams.delete('crop'); return x.toString(); } catch (e) { return u; }
  }
  function collect(scope) {
    var out = [], seen = {};
    scope.querySelectorAll('.product__media-list .product__media-item').forEach(function (li) {
      var im = li.querySelector('.product__media img'); if (!im) return;
      var id = (li.getAttribute('data-media-id') || '').split('-').pop();
      var src = fullRes(im.getAttribute('src') || im.currentSrc);
      if (!src || seen[src]) return; seen[src] = 1;
      out.push({ id: id, src: src, alt: im.getAttribute('alt') || '' });
    });
    return out;
  }
  function build() {
    box = document.createElement('div');
    box.className = 'holo-zl'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Image zoom'); box.hidden = true;
    box.innerHTML = '<div class="holo-zl__stage"><img class="holo-zl__img" alt="" draggable="false"></div>' +
      '<button type="button" class="holo-zl__btn holo-zl__close" aria-label="Close">&times;</button>' +
      '<div class="holo-zl__bar"><button type="button" class="holo-zl__btn" data-z="-1" aria-label="Zoom out">&minus;</button>' +
      '<span class="holo-zl__count" aria-live="polite"></span>' +
      '<button type="button" class="holo-zl__btn" data-z="1" aria-label="Zoom in">+</button></div>' +
      '<button type="button" class="holo-zl__btn holo-zl__nav holo-zl__prev" aria-label="Previous image">&#8249;</button>' +
      '<button type="button" class="holo-zl__btn holo-zl__nav holo-zl__next" aria-label="Next image">&#8250;</button>';
    document.body.appendChild(box);
    stage = box.querySelector('.holo-zl__stage'); img = box.querySelector('.holo-zl__img'); counter = box.querySelector('.holo-zl__count');
    prevB = box.querySelector('.holo-zl__prev'); nextB = box.querySelector('.holo-zl__next');
    box.querySelector('.holo-zl__close').addEventListener('click', close);
    prevB.addEventListener('click', function () { go(-1); });
    nextB.addEventListener('click', function () { go(1); });
    box.querySelectorAll('[data-z]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = +b.getAttribute('data-z');
        zoomTo(d > 0 ? s * 1.5 : Math.max(1, s / 1.5), 0, 0, true);
      });
    });
    box.addEventListener('wheel', onWheel, { passive: false });
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onUp);
    box.addEventListener('keydown', onKey);
    img.addEventListener('load', function () { box.classList.remove('is-loading'); clamp(); paint(); });
  }
  function base() { // fitted image size at scale 1
    var W = stage.clientWidth, H = stage.clientHeight, nw = img.naturalWidth || W, nh = img.naturalHeight || H;
    var k = Math.min(W / nw, H / nh); return { w: nw * k, h: nh * k, W: W, H: H };
  }
  function clamp() {
    var b = base(), mx = Math.max(0, (b.w * s - b.W) / 2), my = Math.max(0, (b.h * s - b.H) / 2);
    tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty));
  }
  function paint(anim) {
    img.style.transition = anim ? 'transform .22s ease-out' : 'none';
    img.style.width = base().w + 'px'; img.style.height = base().h + 'px';
    img.style.transform = 'translate(-50%,-50%) translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + s + ')';
    box.classList.toggle('is-zoomed', s > 1.01);
  }
  // zoom keeping the point (px,py), measured from the stage centre, fixed on screen
  function zoomTo(ns, px, py, anim) {
    ns = Math.max(0.6, Math.min(MAX, ns));
    tx = px - (px - tx) * (ns / s); ty = py - (py - ty) * (ns / s); s = ns;
    if (s >= 1) clamp(); paint(anim);
  }
  function rel(e) { var r = stage.getBoundingClientRect(); return { x: e.clientX - r.left - r.width / 2, y: e.clientY - r.top - r.height / 2 }; }
  function show(i) {
    idx = (i + list.length) % list.length; var it = list[idx];
    s = OPEN_ZOOM; tx = 0; ty = 0;
    box.classList.add('is-loading');
    img.alt = it.alt; img.src = it.src;
    counter.textContent = list.length > 1 ? (idx + 1) + ' / ' + list.length : '';
    prevB.hidden = nextB.hidden = list.length < 2;
    paint();
  }
  function go(d) { if (list.length > 1) show(idx + d); }
  function open(items, startId) {
    if (!box) build();
    list = items; var i = 0;
    items.forEach(function (it, k) { if (it.id === startId) i = k; });
    lastFocus = document.activeElement;
    box.hidden = false; document.documentElement.classList.add('holo-zl-open');
    show(i);
    box.querySelector('.holo-zl__close').focus({ preventScroll: true });
  }
  function close() {
    if (!box || box.hidden) return;
    box.hidden = true; document.documentElement.classList.remove('holo-zl-open'); pts = {}; gesture = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function onWheel(e) {
    e.preventDefault();
    var p = rel(e), f = Math.exp(-e.deltaY * 0.0022);
    zoomTo(Math.max(1, s * f), p.x, p.y);
  }
  function onDown(e) {
    if (e.target.closest('button')) return;
    try { stage.setPointerCapture(e.pointerId); } catch (err) { /* synthetic or already-released pointer */ }
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pts);
    if (ids.length === 1) gesture = { type: 'drag', sx: e.clientX, sy: e.clientY, tx: tx, ty: ty, moved: 0, t: Date.now(), onImg: e.target === img };
    else if (ids.length === 2) {
      var a = pts[ids[0]], b = pts[ids[1]];
      gesture = { type: 'pinch', d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: s, moved: 99 };
    }
  }
  function onMove(e) {
    if (!pts[e.pointerId] || !gesture) return;
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pts);
    if (gesture.type === 'pinch' && ids.length >= 2) {
      var a = pts[ids[0]], b = pts[ids[1]], d = Math.hypot(a.x - b.x, a.y - b.y);
      var m = rel({ clientX: (a.x + b.x) / 2, clientY: (a.y + b.y) / 2 });
      zoomTo(gesture.s * d / gesture.d, m.x, m.y);
    } else if (gesture.type === 'drag') {
      var dx = e.clientX - gesture.sx, dy = e.clientY - gesture.sy;
      gesture.moved = Math.max(gesture.moved, Math.abs(dx) + Math.abs(dy));
      if (s > 1.01) { tx = gesture.tx + dx; ty = gesture.ty + dy; clamp(); paint(); }
    }
  }
  function onUp(e) {
    if (!pts[e.pointerId]) return;
    delete pts[e.pointerId];
    var g = gesture; if (!g) return;
    if (g.type === 'pinch') {
      if (Object.keys(pts).length === 0) { gesture = null; if (s < 1) zoomTo(1, 0, 0, true); }
      return;
    }
    gesture = null;
    var dx = e.clientX - g.sx, dy = e.clientY - g.sy;
    if (g.moved < 10) { // a tap
      var now = Date.now();
      if (now - lastTap < 320) { lastTap = 0; var p = rel(e); zoomTo(s > 1.2 ? 1 : DBL, s > 1.2 ? 0 : p.x, s > 1.2 ? 0 : p.y, true); return; }
      lastTap = now;
      if (!g.onImg) { var t0 = now; setTimeout(function () { if (lastTap === t0) close(); }, 330); }
      return;
    }
    if (s <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? 1 : -1);
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === '+' || e.key === '=') zoomTo(s * 1.5, 0, 0, true);
    else if (e.key === '-') zoomTo(Math.max(1, s / 1.5), 0, 0, true);
    else if (e.key === 'Tab') { // keep focus inside
      var f = [].slice.call(box.querySelectorAll('button:not([hidden])')); if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
  }
  window.addEventListener('resize', function () { if (box && !box.hidden) { clamp(); paint(); } });
  // take over the stock zoom openers on product pages (the image tap and the zoom button)
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.product__media-toggle, .product__media-icon');
    if (!t) return;
    var scope = t.closest('product-info, .product, section') || document;
    var items = collect(scope); if (!items.length) return;
    var li = t.closest('.product__media-item');
    var id = t.getAttribute('data-media-id') || (li ? (li.getAttribute('data-media-id') || '').split('-').pop() : '');
    e.preventDefault(); e.stopImmediatePropagation();
    open(items, id);
  }, true);
})();
